"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const errors_1 = require("@seneca/errors");
class MisSyncServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async teacherFetchSyncConfig(schoolId) {
        const expectedResponses = [200, 403, 404, 422];
        const response = await this.requestMaker.makeRequest(`${this.url}/api/school-sync-configs/teacher/${schoolId}`, {
            method: 'GET'
        }, expectedResponses);
        if (response.status === 404) {
            throw new errors_1.NotFoundError();
        }
        if (response.status === 403) {
            throw new client_library_1.ExtendableError('Forbidden');
        }
        if (response.status === 422) {
            throw new client_library_1.ExtendableError('Unprocessable Entity');
        }
        return response.json;
    }
    async teacherUpdateParentAutoInvites({ schoolId, shouldSendSignupEmailsToParents, parentSignupEmailYearGroups }) {
        const expectedResponses = [200, 403, 404, 422];
        const response = await this.requestMaker.makeRequest(`${this.url}/api/school-sync-configs/teacher/parent-auto-invites/${schoolId}`, {
            method: 'PUT',
            body: JSON.stringify({
                shouldSendSignupEmailsToParents,
                parentSignupEmailYearGroups
            })
        }, expectedResponses);
        if (response.status === 404) {
            throw new errors_1.NotFoundError();
        }
        if (response.status === 403) {
            throw new client_library_1.ExtendableError('Forbidden');
        }
        if (response.status === 422) {
            throw new client_library_1.ExtendableError('Unprocessable Entity');
        }
        return response.json;
    }
}
exports.default = MisSyncServiceClient;
//# sourceMappingURL=MisSyncServiceClient.js.map